export default __webpack_public_path__ + "static/media/Tasks.eaccab23.png";